"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");
var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HereKeyStore = void 0;
var key_pair_1 = require("near-api-js/lib/utils/key_pair");
var JSONStorage_1 = require("./JSONStorage");
var HereKeyStore = /*#__PURE__*/function () {
  function HereKeyStore() {
    var storage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new JSONStorage_1.StateStorage();
    _classCallCheck(this, HereKeyStore);
    this.storage = storage;
  }
  _createClass(HereKeyStore, [{
    key: "setActiveAccount",
    value: function setActiveAccount(network, id) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var state;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.storage.getState(network);
            case 2:
              state = _context.sent;
              state.activeAccount = id;
              this.storage.setState(network, state);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "setKey",
    value: function setKey(networkId, accountId, keyPair) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var state;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.storage.getState(networkId);
            case 2:
              state = _context2.sent;
              state.accounts[accountId] = keyPair.toString();
              this.storage.setState(networkId, state);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "getAccounts",
    value: function getAccounts(network) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var state;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.storage.getState(network);
            case 2:
              state = _context3.sent;
              return _context3.abrupt("return", Object.keys(state.accounts));
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "getActiveAccount",
    value: function getActiveAccount(network) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var state;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.storage.getState(network);
            case 2:
              state = _context4.sent;
              return _context4.abrupt("return", state.activeAccount);
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "getKey",
    value: function getKey(networkId, accountId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var state, privateKey, keyPair;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this.storage.getState(networkId);
            case 2:
              state = _context5.sent;
              privateKey = state.accounts[accountId];
              if (!(privateKey == null)) {
                _context5.next = 6;
                break;
              }
              throw Error("For ".concat(accountId, " in ").concat(networkId, " network key not found"));
            case 6:
              keyPair = key_pair_1.KeyPair.fromString(privateKey);
              return _context5.abrupt("return", keyPair);
            case 8:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "removeKey",
    value: function removeKey(networkId, accountId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var state;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return this.storage.getState(networkId);
            case 2:
              state = _context6.sent;
              if (state.activeAccount === accountId) {
                state.activeAccount = null;
              }
              delete state.accounts[accountId];
              this.storage.setState(networkId, state);
            case 6:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "getNetworks",
    value: function getNetworks() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var state;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return this.storage.getFullState();
            case 2:
              state = _context7.sent;
              return _context7.abrupt("return", Object.keys(state.accounts));
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: "clear",
    value: function clear() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return this.storage.clear();
            case 2:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
    }
  }]);
  return HereKeyStore;
}();
exports.HereKeyStore = HereKeyStore;